import Header from "@/components/Header";
import Hero from "@/components/Hero";
import LogoMarquee from "@/components/LogoMarquee";
import Services from "@/components/Services";
import WhyUs from "@/components/WhyUs";
import Fleet from "@/components/Fleet";
import TrackingBar from "@/components/TrackingBar";
import QuoteForm from "@/components/QuoteForm";
import Testimonials from "@/components/Testimonials";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";

export default function Landing() {
  return (
    <SmoothScroll>
      <div className="bg-white" data-testid="landing-page">
        <Header />
        <main>
          <Hero />
          <LogoMarquee />
          <Services />
          <WhyUs />
          <Fleet />
          <TrackingBar />
          <QuoteForm />
          <Testimonials />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
